jQuery(function ($) {
    var eventsData = cnkCal.events,
        todayStr = cnkCal.today,
        $calBody = $('#calendar-body'),
        $header = $('#calendar-month-year'),
        $reset = $('#calendar_reset'),
        selectedTd = null,
        currentMonth, currentYear;

    function fmtDMY(d) {
        var dd = String(d.getDate()).padStart(2, '0'),
            mm = String(d.getMonth() + 1).padStart(2, '0'),
            yy = d.getFullYear();
        return dd + '.' + mm + '.' + yy;
    }

    function fmtYMD(d) {
        var dd = String(d.getDate()).padStart(2, '0'),
            mm = String(d.getMonth() + 1).padStart(2, '0'),
            yy = d.getFullYear();
        return yy + '-' + mm + '-' + dd;
    }

    var days = ["PON", "WTO", "ŚRO", "CZW", "PT", "SOB", "ND"];
    var html = "";
    days.forEach(d => html += "<th>" + d + "</th>");
    html += "";
    $('#calendar-day-names').html(html);

    var today = new Date();
    currentMonth = today.getMonth();
    currentYear = today.getFullYear();

    function updateHeader() {
        var months = ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"];
        var name = months[currentMonth];
        $header.text(name.charAt(0).toUpperCase() + name.slice(1) + " " + currentYear);
    }

    function generateCalendar() {
        updateHeader();
        var first = new Date(currentYear, currentMonth, 1),
            start = first.getDay() || 7,
            daysIn = new Date(currentYear, currentMonth + 1, 0).getDate(),
            html = "<tr>";

        for (var i = 1; i < start; i++) {
            html += "<td class='empty'></td>";
        }
        for (var d = 1; d <= daysIn; d++) {
            var idx = ((start - 1) + (d - 1)) % 7;
            if (idx === 0 && d > 1) html += "</tr><tr>";
            var cls = "", dt = new Date(currentYear, currentMonth, d),
                ymd = fmtYMD(dt);
            if (ymd === todayStr) cls += " today";
            if (dt.getDay() === 6) cls += " saturday";
            if (dt.getDay() === 0) cls += " sunday";
            html += "<td data-date='" + ymd + "' class='" + cls.trim() + "'>" + d + "</td>";
        }
        var rem = ((start - 1) + daysIn) % 7;
        if (rem) {
            for (var k = 0; k < 7 - rem; k++) {
                html += "<td class='empty'></td>";
            }
        }
        html += "</tr>";
        $calBody.html(html);

        $calBody.find('td').each(function () {
            var $td = $(this);
            if ($td.hasClass('empty')) return;
            $td.off('mouseenter mouseleave click')
                .on('mouseenter', function () {
                    $td.addClass('today-hover');
                })
                .on('mouseleave', function () {
                    $td.removeClass('today-hover');
                })
                .on('click', function () {
                    selectDate($td.data('date'));
                    if (selectedTd) selectedTd.removeClass('selected');
                    $('.today').removeClass('today');
                    $td.addClass('selected');
                    selectedTd = $td;
                });
        });
    }

    function selectDate(ymd) {
        var isPast = ymd < todayStr;

        var arr = eventsData.filter(function (it) {
            var parts = it.date.split('/'),
                dt = new Date(parts[2], parts[1] - 1, parts[0]),
                dtYmd = fmtYMD(dt);

            if (dtYmd !== ymd) return false;
            if (!isPast && dtYmd < todayStr) return false;
            return true;
        });

        renderEvents(arr);
    }


    function renderEvents(arr) {
        var $c = $('#events-container');
        if (!arr.length) {
            $c.html('<p>Brak wydarzeń dla tej daty.</p>');
            return;
        }

        var out = '<div>';
        var lastDate = '';

        arr.forEach(function (it) {
            var parts = it.date.split('/'),
                dt = new Date(parts[2], parts[1] - 1, parts[0]),
                dmy = fmtDMY(dt);

            if (dmy !== lastDate) {
                out += '<p class="event_date">' + dmy + '</p>';
                lastDate = dmy;
            }

            out +=
                '<div class="event">' +
                '<p class="event_name">' + it.repeater_text + '</p>' +
                '<div>' + it.repeater_wysiwyg + '</div>' +
                '</div>';
        });

        out += '</div>';
        $c.html(out);
    }


    function loadAllEvents() {
        var arr = eventsData.filter(function (it) {
            var parts = it.date.split('/'),
                d = new Date(parts[2], parts[1] - 1, parts[0]);
            return fmtYMD(d);
        });
        arr.sort(function (a, b) {
            var pa = a.date.split('/'), pb = b.date.split('/'),
                da = new Date(pa[2], pa[1] - 1, pa[0]),
                db = new Date(pb[2], pb[1] - 1, pb[0]);
            return da - db;
        });
        renderEvents(arr);
    }

    function showNearest() {
        var upcoming = eventsData.filter(function (it) {
            var parts = it.date.split('/'),
                dt = new Date(parts[2], parts[1] - 1, parts[0]);
            return fmtYMD(dt) >= todayStr;
        });

        if (!upcoming.length) {
            $('#events-container').html('<p>Brak nadchodzących wydarzeń.</p>');
            return;
        }

        upcoming.sort(function (a, b) {
            var da = a.date.split('/'), db = b.date.split('/'),
                dA = new Date(da[2], da[1] - 1, da[0]),
                dB = new Date(db[2], db[1] - 1, db[0]);
            return dA - dB;
        });

        renderEvents(upcoming);

        var ymd = fmtYMD(new Date(upcoming[0].date.split('/').reverse().join('-')));
        var $cell = $calBody.find("td[data-date='" + ymd + "']");
        if ($cell.length) {
            $cell.trigger('click');
        }
        renderEvents(upcoming);
    }


    generateCalendar();
    showNearest();

    $reset.on('click', function () {
        if (selectedTd) selectedTd.removeClass('selected');
        loadAllEvents();
    });

    $('#prev-month').click(function (e) {
        e.preventDefault();
        currentMonth--;
        if (currentMonth < 0) {
            currentMonth = 11;
            currentYear--;
        }
        generateCalendar();
    });
    $('#next-month').click(function (e) {
        e.preventDefault();
        currentMonth++;
        if (currentMonth > 11) {
            currentMonth = 0;
            currentYear++;
        }
        generateCalendar();
    });

    generateCalendar();
    showNearest();

});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wpcf7-submit').forEach(function (input) {
        var wrap = document.createElement('span');
        wrap.className = 'submit-with-icon';
        input.parentNode.insertBefore(wrap, input);
        wrap.appendChild(input);
    });

    var textarea = document.querySelector('textarea[name="your-message"]');
    var counter = document.getElementById('char_counter');
    if (!textarea || !counter) return;

    var max = textarea.getAttribute('maxlength') || textarea.maxLength;
    if (max < 0) max = 0;

    function updateCounter() {
        var len = textarea.value.length;
        counter.textContent = len + '/' + max;
    }

    textarea.addEventListener('input', updateCounter);

    updateCounter();


});


document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('section:not(.video_top-pick_city)');

    const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, {threshold: 0.1});

    sections.forEach(sec => io.observe(sec));
});


document.addEventListener('DOMContentLoaded', function(){
    const playSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 27">
      <path d="M22.5 12.634C23.1667 13.0189 23.1667 13.9811 
               22.5 14.366L2.25 26.0574C1.58333 26.4423 
               0.750001 25.9611 0.750001 25.1913L0.750002 
               1.80866C0.750002 1.03886 1.58334 0.557731 
               2.25 0.942631L22.5 12.634Z" fill="white"/>
    </svg>
  `;

    function injectPlayIcon(){
        const btns = document.querySelectorAll('.mejs-overlay-button');
        if (!btns.length) return;
        btns.forEach(btn => {
            if (!btn.querySelector('svg')) {
                btn.innerHTML = playSVG;
            }
        });
    }

    const intervalId = setInterval(() => {
        injectPlayIcon();
        if (document.querySelector('.mejs-overlay-button svg')) {
            clearInterval(intervalId);
        }
    }, 200);



    document.addEventListener('show.bs.modal', () => {
        document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
    });
    document.addEventListener('show.bs.modal', e => {
        document.body.appendChild(e.target);
    });

});



jQuery(function($){
    $(document)
        .off('submit.solutionForm')
        .on('submit.solutionForm', '.solution-form', function(e){
            e.preventDefault();

            var form = $(this),
                data = form.serialize()
                    + '&action=submit_problem_solution'
                    + '&solution_nonce_field=' + my_ajax.nonce;

            $.post(my_ajax.url, data)
                .done(function(resp){
                    if (resp.success) {
                        form[0].reset();
                        form.closest('.modal').modal('hide');

                        // --- fix scroll ---
                        $('body').css({
                            'overflow': '',
                            'padding-right': ''
                        });
                        $('.modal-backdrop').remove();
                    } else {
                        console.log('Błąd: ' + resp.data);
                    }
                })
                .fail(function(){
                    console.log('Błąd połączenia z serwerem.');
                });
        });

    // opcjonalnie, globalny cleanup po każdym zamknięciu modala
    $('.modal').on('hidden.bs.modal', function () {
        $('body').css({
            'overflow': '',
            'padding-right': ''
        });
        $('.modal-backdrop').remove();
    });
});

jQuery(function($){
    $('.modal_problems').on('change','input[type=checkbox]',function(){
        // odznacz wszystkie inne w tym samym .modal-body
        $(this)
            .closest('.modal-body')
            .find('input[type=checkbox]')
            .not(this)
            .prop('checked', false);
    });
});


jQuery(function($){
    $('.modal_problems').on('click', '.solve_button', function(e){
        // Jeśli już w tym cyklu klik był obsłużony → wyjście
        if ($(this).data('clicked')) {
            return;
        }
        $(this).data('clicked', true);
        setTimeout(() => $(this).removeData('clicked'), 0);

        // Stop propagation, żeby nie było drugiego kliknięcia
        e.stopPropagation();
        e.preventDefault();

        console.log('Kliknięto solve_button:', this, 'target:', e.target.tagName);

        var cb = $(this).find('input[type="checkbox"]');
        console.log('Stan PRZED:', cb.prop('checked'));

        var isChecked = !cb.prop('checked');
        cb.prop('checked', isChecked);
        console.log('Stan PO:', isChecked);

        var odznaczone = $(this).closest('.modal-body')
            .find('input[type="checkbox"]')
            .not(cb)
            .prop('checked', false)
            .parent('.solve_button').removeClass('checked');
        console.log('Odznaczone inne:', odznaczone.length);

        $(this).toggleClass('checked', isChecked);
        console.log('Klasa .checked ustawiona?', $(this).hasClass('checked'));
        console.log('--- KONIEC KLIK ---');
    });

    // Dla klików w input/label – zatrzymujemy propagację
    $('.modal_problems').on('click', '.solve_button input, .solve_button label', function(e){
        e.stopPropagation();
    });
});








document.addEventListener('DOMContentLoaded', function(){
    var collapseEl = document.getElementById('navbarNavDropdown');
    var toggler   = document.getElementById('nav-toggle-mobile');
    if (!collapseEl || !toggler) {
/*
        console.warn('collapse-fix: brak elementów #navbarNavDropdown lub #nav-toggle-mobile');
*/
        return;
    }

    // 1) wyłącz domyślne data-api Bootstrapa (jeśli nadal były w HTML)
    toggler.removeAttribute('data-bs-toggle');
    toggler.removeAttribute('data-bs-target');

    // 2) utwórz instancję bez automatycznego toggle (toggle: false)
    var bsColl = bootstrap.Collapse.getOrCreateInstance(collapseEl, {
        toggle: false
    });

    // 3) logowanie stanów (opcjonalne, ale pomaga debugować)
    collapseEl.addEventListener('show.bs.collapse', function(){
/*
        console.log('[collapse] zdarzenie show.bs.collapse');
*/
    });
    collapseEl.addEventListener('hide.bs.collapse', function(){
/*
        console.log('[collapse] zdarzenie hide.bs.collapse');
*/
    });

    // 4) throttling: tylko jedno toggle na 500ms
    var lastToggle = 0;
    toggler.addEventListener('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();

        var now = Date.now();
/*
        console.log(`[click] otrzymane w ${now}, obecny stan show=${collapseEl.classList.contains('show')}`);
*/

        if ( now - lastToggle < 50 ) {
/*
            console.log('[click] pomijam – za szybko po poprzednim (' + (now - lastToggle) + 'ms)');
*/
            return;
        }
        lastToggle = now;

        // 5) ręczne przełączenie
        bsColl.toggle();
/*        console.log('[action] toggle() wykonany, nowy stan show='
            + collapseEl.classList.contains('show'));*/
    });
});

jQuery(document).ready(function($) {
    $(document).on('click', '.projects-pagination a', function(e) {
        e.preventDefault();

        let href = $(this).attr('href');
        let page = 1;

        let pagedMatch = href.match(/\/page\/([0-9]+)/); // dla pretty permalinks
        if (pagedMatch) {
            page = pagedMatch[1];
        } else {
            let queryMatch = href.match(/[?&]paged=([0-9]+)/); // dla query string
            if (queryMatch) {
                page = queryMatch[1];
            }
        }

        let container = $('#projekty-container');
        let city = container.data('city');

        $.ajax({
            url: ajaxurl, // WordPress automatycznie ustawia ajaxurl w admin-ajax.php
            type: 'POST',
            data: {
                action: 'load_projekty',
                paged: page,
                city: city
            },
            beforeSend: function() {
                $('#projekty-list').css('opacity', '0.5');
            },
            success: function(response) {
                if (response.success) {
                    $('#projekty-list').html(response.data).css('opacity', '1');
                    $('html, body').animate({
                        scrollTop: $("#projekty-container").offset().top - 100
                    }, 200);
                }
            }
        });
    });
});


jQuery(document).on('input change', '.rating_input', function () {
    const modal = jQuery(this).closest('.modal');
    modal.find('.rating_value').text(jQuery(this).val());
});
